import type { ContactNumbersJourney } from '@app/services/contactNumbers';

export type ContactNumbersRefreshOverride = {
  journey?: ContactNumbersJourney;
  platform?: string | null;
};

type RefreshFn = (override?: ContactNumbersRefreshOverride) => Promise<void>;

let refreshFn: RefreshFn | null = null;

export function registerContactNumbersRefresh(fn: RefreshFn | null) {
  refreshFn = fn;
}

export async function refreshContactNumbersAfterUserApi(
  override?: ContactNumbersRefreshOverride,
): Promise<void> {
  if (refreshFn) {
    await refreshFn(override);
  }
}

export const getJourneyFromUserResponse = (
  response: any,
): ContactNumbersJourney => {
  return (response?.linkedCredits?.length ?? 0) > 0 ? 'LMS' : 'LOS';
};

export const getPlatformFromUserResponse = (response: any): string | null => {
  return response?.linkedPlatformAccounts?.[0]?.platformCode ?? 'VOLT_WEB_APP';
};
